import { Select } from '@a0/quantum-product';
import React from 'react';
var SelectApi = function (_a) {
    var _b;
    var apis = _a.apis, selectedApiId = _a.selectedApiId, handleApiChange = _a.handleApiChange;
    return (React.createElement(Select, { onChange: function (event) { return handleApiChange(event.target.value); }, value: (_b = apis.find(function (api) { return api.id === selectedApiId; })) === null || _b === void 0 ? void 0 : _b.id }, apis.map(function (api) { return (React.createElement("option", { key: api.id, value: api.id }, api.name)); })));
};
export default SelectApi;
